import axios from "axios";
import { create } from "zustand";
import { CATEGORY_IMAGE_URL } from "../constant";

const categoryStore = create((set) => ({
  MAX_FILE_SIZE: 1500,
  mCategory: null,
  category: null,
  isLoading: true,
  _id: null,
  imagePreviewOfWomen: null,
  imagePreviewOfMen: null,
  imagePreviewOfKids: null,

  categoryForm: {
    categoryName: "",
    isWomenImage: true,
    categoryImageOfWomen: "",
    isMenImage: false,
    categoryImageOfMen: "",
    isKidsImage: false,
    categoryImageOfKids: "",
  },

  clearCategoryForm: () => {
    set({
      categoryForm: {
        categoryName: "",
        isWomenImage: true,
        categoryImageOfWomen: "",
        isMenImage: false,
        categoryImageOfMen: "",
        isKidsImage: false,
        categoryImageOfKids: "",
      },
    });
    set({
      imagePreviewOfWomen: null,
      imagePreviewOfMen: null,
      imagePreviewOfKids: null,
    });
  },

  fillCategoryId: ({ value }) => {
    set({ _id: value });
  },

  fillCategoryName: (e) => {
    const { name, value } = e.target;
    set((state) => {
      return {
        categoryForm: {
          ...state.categoryForm,
          [name]: value,
        },
      };
    });
  },

  fillCategoryImage: async ({ files, name }) => {
    const { convertToBase64, MAX_FILE_SIZE } = categoryStore.getState();
    if (MAX_FILE_SIZE < files[0].size / 1024) {
      return false;
    }

    set((state) => {
      return {
        categoryForm: {
          ...state.categoryForm,
          [name]: files[0],
        },
      };
    });

    // const base64 = await convertToBase64(files[0]);
    const img = URL.createObjectURL(files[0]);

    if (name === "categoryImageOfWomen") {
      set({ imagePreviewOfWomen: img });
    }
    if (name === "categoryImageOfMen") {
      set({ imagePreviewOfMen: img });
    }
    if (name === "categoryImageOfKids") {
      set({ imagePreviewOfKids: img });
    }
    return true;
  },

  clearCategoryImage: ({ name }) => {
    set((state) => {
      return {
        categoryForm: {
          ...state.categoryForm,
          [name]: "",
        },
      };
    });

    if (name === "categoryImageOfWomen") {
      set({ imagePreviewOfWomen: null });
    }
    if (name === "categoryImageOfMen") {
      set({ imagePreviewOfMen: null });
    }
    if (name === "categoryImageOfKids") {
      set({ imagePreviewOfKids: null });
    }
  },

  setSwitchOnOrOff: ({ name, value }) => {
    set((state) => {
      return {
        categoryForm: {
          ...state.categoryForm,
          [name]: value,
        },
      };
    });
  },

  convertToBase64: (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  },

  createCategory: async () => {
    // e.preventDefault();
    const { categoryForm, clearCategoryForm } = categoryStore.getState();
    // Create the Category
    if (
      categoryForm.categoryName !== "" &&
      categoryForm.categoryImageOfWomen !== ""
    ) {
      var bodyFormData = new FormData();
      bodyFormData.append("categoryName", categoryForm.categoryName);
      bodyFormData.append("isWomenImage", categoryForm.isWomenImage);
      bodyFormData.append("isMenImage", categoryForm.isMenImage);
      bodyFormData.append("isKidsImage", categoryForm.isKidsImage);

      if (categoryForm.categoryImageOfWomen) {
        bodyFormData.append(
          "categoryImageOfWomen",
          categoryForm.categoryImageOfWomen
        );
      }
      if (categoryForm.categoryImageOfMen) {
        bodyFormData.append(
          "categoryImageOfMen",
          categoryForm.categoryImageOfMen
        );
      }
      if (categoryForm.categoryImageOfKids) {
        bodyFormData.append(
          "categoryImageOfKids",
          categoryForm.categoryImageOfKids
        );
      }

      const res = await axios.post("/create-category", bodyFormData);

      if (res) {
        clearCategoryForm();

        return true;
      }
    } else {
      alert("fill");
      return false;
    }
  },

  fetchCategory: async () => {
    // Fetch category
    const res = await axios.get("/fetch-all-category");
    // set category to state
    set({ category: res.data.category, mCategory: res.data.category });
    set({ isLoading: false });
  },

  fetchOneCategory: async () => {
    // Get Id
    const { _id } = categoryStore.getState();

    // Fetch One Category
    const res = await axios.get(`/fetch-one-category/${_id}`);
    // set category
    set({
      categoryForm: {
        categoryName: res.data.category.categoryName,
        isWomenImage: res.data.category.isWomenImage,
        categoryImageOfWomen: res.data.category.categoryImageOfWomen,
        isMenImage: res.data.category.isMenImage,
        categoryImageOfMen: res.data.category.categoryImageOfMen,
        isKidsImage: res.data.category.isKidsImage,
        categoryImageOfKids: res.data.category.categoryImageOfKids,
      },
    });
    set({
      imagePreviewOfWomen: res.data.category.categoryImageOfWomen
        ? `${CATEGORY_IMAGE_URL}${res.data.category.categoryImageOfWomen}`
        : null,
      imagePreviewOfMen: res.data.category.categoryImageOfMen
        ? `${CATEGORY_IMAGE_URL}${res.data.category.categoryImageOfMen}`
        : null,
      imagePreviewOfKids: res.data.category.categoryImageOfKids
        ? `${CATEGORY_IMAGE_URL}${res.data.category.categoryImageOfKids}`
        : null,
    });
  },

  updateCategory: async () => {
    try {
      const {
        categoryForm: {
          categoryName,
          isWomenImage,
          categoryImageOfWomen,
          isMenImage,
          categoryImageOfMen,
          isKidsImage,
          categoryImageOfKids,
        },
        _id,
      } = categoryStore.getState();

      if (categoryName !== "" && categoryImageOfWomen !== "") {
        // Send the update request
        var bodyFormData = new FormData();
        bodyFormData.append("categoryName", categoryName);
        bodyFormData.append("isWomenImage", isWomenImage);
        bodyFormData.append("isMenImage", isMenImage);
        bodyFormData.append("isKidsImage", isKidsImage);

        if (categoryImageOfWomen) {
          bodyFormData.append("categoryImageOfWomen", categoryImageOfWomen);
        }
        if (categoryImageOfMen) {
          bodyFormData.append("categoryImageOfMen", categoryImageOfMen);
        }
        if (categoryImageOfKids) {
          bodyFormData.append("categoryImageOfKids", categoryImageOfKids);
        }

        await axios.put(`/update-category/${_id}`, bodyFormData);

        // update state

        set({
          _id: null,
          categoryForm: {
            categoryName: "",
            categoryImageOfWomen: "",
          },
        });
        return true;
      } else {
        alert("fill data");
        return false;
      }
    } catch (error) {
      console.log("error: ", error);
    }
  },

  updateCategoryStatus: async ({ _id, status }) => {
    const { category, clearCategoryForm } = categoryStore.getState();

    // Send the update request
    const res = await axios.put(`/update-category-status/${_id}`, {
      status,
    });

    // Update state
    const newCategory = [...category];
    const noteCategory = category.findIndex((c) => {
      return c._id === _id;
    });
    newCategory[noteCategory] = res.data.category;

    set({
      category: newCategory,
    });
    clearCategoryForm();
    return true;
  },

  SearchCategory: async ({ categoryName }) => {
    /* for api */

    // try {
    //   // Fetch Category
    //   const res = await axios.get(`/fetch-search-category/${categoryName}`);

    //   // set category
    //   set({ category: res.data.category });
    // } catch (error) {
    //   console.log(error);
    // }

    /* for api */

    const { mCategory } = categoryStore.getState();

    if (categoryName !== "") {
      set({
        category: mCategory.filter((item) => {
          return item.categoryName
            .toLowerCase()
            .includes(categoryName.toLowerCase());
        }),
      });
    } else {
      set({ category: mCategory });
    }
  },
}));

export default categoryStore;
